var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper"},[(_vm.show)?_c('Header'):_vm._e(),(_vm.show)?_c('Sidebar'):_vm._e(),_c('router-view'),_c('div',{staticClass:"modal-backdrop fade hide",attrs:{"id":"backdrop"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }